import { useEffect, useState } from 'react';
import { svgs } from '../../assets/svgs';
import { RegisterForm } from './RegisterForm';
import { useBlur } from '../../hooks/useBlur';


export const Ticket = ({ type, ticket, benefits, discount }) => {
   const [isShowMore, setIsShowMore] = useState(false)
   const [isModalOpen, setIsModalOpen] = useState(false)
   const [isLoading, setIsLoading] = useState(false)
   const modalRef = useBlur(() => setIsModalOpen(false))

   const handleClick = () => {
      setIsModalOpen(true)
      var bz = document.createElement('script');
      bz.type = 'text/javascript';
      bz.async = true;
      bz.src = 'https://organizer.bizzabo.com/widgets/tickets/tickets.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(bz, s);
   }
   // const handleClick = () => {
   //    setIsModalOpen(true)
   //    const script = document.createElement('script');
   //    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
   //    document.body.appendChild(script);
   //    script.addEventListener('load', () => {
   //       if (window.hbspt) {
   //          setIsLoading(false)
   //          window.hbspt.forms.create({
   //             region: "na1",
   //             portalId: "536350",
   //             formId: "5f67c12f-e4b9-4386-950a-ce96f986918f",
   //             target: '#contactForm',
   //          })
   //       }
   //    });
   // }

   return (
      <div className='ticket' style={{ background: ticket.bgColor }}>
         <header>
            <div className='circle top left'></div>
            <div className='circle top right'></div>
            <h1>Ticket Type</h1>
            <h2>{ticket.name}{ticket.name === 'Platinum' && ' Package'}</h2>
            <h3><sup>$</sup>{ticket.price - discount}</h3>
            {discount > 0 && <h4><sup>$</sup>{ticket.price}</h4>}
            <h5 style={{ visibility: ticket.name !== 'Platinum' && 'hidden' }}>Includes 3 Tickets</h5>
            <div className="btn-container">
               <button onClick={handleClick} className='btn b3'>book now</button>
            </div>
         </header>
         <section className='cards-separaiter'>
            <div className='circle middle left'></div>
            <div className='recs'>
               <div className='rec'></div>
               <div className='rec'></div>
               <div className='rec'></div>
               <div className='rec'></div>
            </div>
            <div className='circle middle right'></div>
         </section>
         <main>
            <button onClick={() => setIsShowMore(!isShowMore)} className={isShowMore ? 'show-more open' : 'show-more'}>
               <p>Show Benefits</p>
               {svgs.arrowDown}
            </button>
            <ul className='desktop-list'>
               {
                  benefits.map((benefit, index) =>
                     <li key={index}>{ticket.benefits[index] ? svgs.check : svgs.clear}</li>
                  )
               }
            </ul>
            <ul className={isShowMore ? 'mobile-list open' : 'mobile-list'}>
               {
                  ticket.benefits.map((benefit, index) =>
                     <li key={index}>{benefit}</li>
                  )
               }
            </ul>
         </main>
         <footer>
            <div className='circle bottom left'></div>
            <div className='circle bottom right'></div>
         </footer>
         {
            isModalOpen &&
            <section>
               {/* <div className="modal-container" onClick={() => setIsModalOpen(false)}> */}
               <div className="modal-container">
                  <div className="ticket-modal" ref={modalRef}>
                     {isLoading && <div id="loader" ></div>}
                     {/* {!isLoading && <div id="contactForm" />} */}
                     <div
                        style={{ overflow: 'scroll', borderRadius: '10px' }}
                        id='biza-prc-div'
                        className='bizzabo-tickets-widget'
                        data-event-id='538979'
                        data-params={`isInMinisite=true&widgetId=${ticket.widgetId}`}
                     />
                     {/* <RegisterForm ticket={ticket} setIsModalOpen={setIsModalOpen}/> */}
                  </div>
               </div>
            </section>
         }
      </div>
   )
}
